var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderPackingDetail',{attrs:{"label":"Reimbursement","type":"reimbursement","movement-type":"main","index-path":{ name: 'gudang.reimbursement.index' },"pengemasan-path":"gudang.reimbursement.pengemasan"}})
}
var staticRenderFns = []

export { render, staticRenderFns }